import {
  daysJsFormat,
  languagesList,
  renderStatusPrestation,
  renderStatusTag,
  renderTypePrestation,
  renderUserName,
  renderUserNameEmail,
  roles,
  statusControlList,
  statusPrestations,
  subRoles,
  subStatusPrestations,
  typeIntervention,
} from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import dayjs from "../../../utils/dayjs";
import React from "react";
import { Button, Space, Tag, theme } from "antd";
import { BiSearch } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export const columnsPrestationsList = (sortedPrestations, searchState) => {
  const uniqueValuesSetCategory = new Set();

  const { advancedCols = false } = searchState;

  sortedPrestations.map(obj => {
    obj?.category?.map(cat => {
      uniqueValuesSetCategory.add(cat);
    });
    uniqueValuesSetCategory.add(obj.type);
  });

  const uniqueSubStatus = new Set();

  sortedPrestations.map(obj => {
    if (obj?.subStatus) {
      uniqueSubStatus.add(obj.subStatus);
    }
  });

  let arrayCols = [
    {
      title: "N°",
      width: 100,
      dataIndex: "reference",
      key: "reference",
      sorter: (a, b) => {
        return a?.reference - b?.reference;
      },
    },
    {
      title: "Interprete",
      dataIndex: "interprete",
      key: "interprete",
      sorter: (a, b) => {
        const nameA = renderUserName(a.interprete);
        const nameB = renderUserName(b.interprete);

        return nameA.localeCompare(nameB);
      },
      visible: userHasLevel({
        not: {
          [roles.interprete]: "r", //
        },
      }),
      render: (interprete, record) => {
        return <b>{renderUserName(interprete)}</b>;
      },
    },
    {
      title: "Institution",
      visible: userHasLevel({
        not: {
          [roles.institution]: "r", //
        },
      }),
      dataIndex: "institution",
      key: "institution",
      sorter: (a, b) => a.institution?.name.localeCompare(b.institution?.name),
      render: institution => {
        return institution?.name;
      },
    },
    {
      title: "Référence bénéficiaire",
      sm: false,
      dataIndex: "beneficiary",
      key: "beneficiary",
      sorter: (a, b) =>
        a.beneficiary.reference.localeCompare(b.beneficiary.reference),
      render: beneficiary => {
        return beneficiary?.reference;
      },
    },
    {
      title: "Lieu d'intervention",
      dataIndex: "intervention.location",
      key: "intervention.location",
      render: (intervention, record) => {
        return record.intervention.location;
      },
    },
    {
      title: "Demandeur",
      dataIndex: "applicant",
      key: "applicant",
      render: (type, item) => {
        return renderUserName(item.applicant);
      },
      sorter: (a, b) => {
        return a?.applicant?._id?.localeCompare(b?.applicant?._id);
      },
    },
    {
      title: "Début",
      dataIndex: "finalStartDate",
      key: "finalStartDate",
      render: (n, record) => (
        <>{dayjs(record.finalStartDate).format(daysJsFormat.full)}</>
      ),
      sorter: (a, b) => new Date(a.finalStartDate) - new Date(b.finalStartDate),
    },
    {
      title: "Fin",
      dataIndex: "finalEndDate",
      key: "finalEndDate",
      render: (n, record) => (
        <>{dayjs(record.finalEndDate).format(daysJsFormat.full)}</>
      ),
      sorter: (a, b) => new Date(a.finalEndDate) - new Date(b.finalEndDate),
    },
    {
      title: "Etat de la commande",
      sm: false,
      dataIndex: "status",
      key: "status",
      width: "200px",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (status, record) => {
        return (
          <>
            <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
              {renderStatusPrestation(record, { showControls: true })}
            </ActionRoleSpecific>

            <ActionRoleSpecific only={[roles.interprete, roles.institution]}>
              {renderStatusPrestation(record, { showControls: false })}
            </ActionRoleSpecific>
          </>
        );
      },
    },
  ];

  if (advancedCols === true) {
    arrayCols.push({
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (n, record) => {
        return <>{renderTypePrestation(record.intervention.type)}</>;
      },
    });

    arrayCols.push({
      title: "Début prévue",
      dataIndex: "intervention.startDate",
      key: "intervention.startDate",
      render: (n, record) => (
        <>{dayjs(record.intervention.startDate).format(daysJsFormat.full)}</>
      ),
      sorter: (a, b) => new Date(a.finalStartDate) - new Date(b.finalStartDate),
    });

    arrayCols.push({
      title: "Fin prévue",
      dataIndex: "intervention.endDate",
      key: "intervention.endDate",
      render: (n, record) => (
        <>{dayjs(record.intervention.endDate).format(daysJsFormat.full)}</>
      ),
      sorter: (a, b) => new Date(a.finalEndDate) - new Date(b.finalEndDate),
    });

    arrayCols.push({
      title: "Durée effective",
      dataIndex: "bill",
      key: "bill",
      render: (n, record) => {
        let tranchesTime = 0;
        if (record.intervention.type === typeIntervention.in_person) {
          tranchesTime = 15;
        } else {
          tranchesTime = 10;
        }

        let prestationNormal = undefined;
        let prestationSpecial = undefined;

        let isUrgent = false;
        let isHorsCanton = false;

        if (record.bill?.type === "unique") {
          prestationNormal = record?.bill?.costs?.find(
            e => e.type === "prestation",
          );
          prestationSpecial = record?.bill?.costs?.find(
            e => e.type === "night",
          );

          isUrgent = record?.bill?.costParams.isUrgent;
          isHorsCanton = record?.bill?.costParams.isHorsCanton;
        }
        if (record.bill?.type === "multiple") {
          prestationNormal = record?.bill?.costsMultiple
            ?.find(e => e.prestationId === record._id)
            ?.cost?.find(e => e.type === "prestation");
          prestationSpecial = record?.bill?.costsMultiple
            ?.find(e => e.prestationId === record._id)
            ?.cost?.find(e => e.type === "night");

          isUrgent = record?.bill?.costsMultiple?.find(
            e => e.prestationId === record._id,
          )?.costParams.isUrgent;
          isHorsCanton = record?.bill?.costsMultiple?.find(
            e => e.prestationId === record._id,
          )?.costParams.isHorsCanton;
        }

        return (
          <span>
            {record?.bill === undefined || record?.bill === null ? (
              <Tag color={"grey"}>Non facturé</Tag>
            ) : null}

            {prestationNormal && (
              <p style={{ margin: 0 }}>
                Normal {prestationNormal.tranches * tranchesTime} min
              </p>
            )}
            {prestationSpecial && (
              <p style={{ margin: 0 }}>
                Special {prestationSpecial.tranches * tranchesTime} min
              </p>
            )}
            {isUrgent && <Tag color={"red-inverse"}>Urgent</Tag>}
            {isHorsCanton && <Tag color={"blue-inverse"}>Hors canton</Tag>}
          </span>
        );
      },
    });
    arrayCols.push({
      title: "Kms facturés",
      dataIndex: "bill",
      key: "bill",
      render: (n, record) => {
        let travel = undefined;
        if (record.bill?.type === "unique") {
          travel = record?.bill?.costs?.find(e => e.type === "travel");
        }
        if (record.bill?.type === "multiple") {
          travel = record?.bill?.costsMultiple
            ?.find(e => e.prestationId === record._id)
            ?.costs?.find(e => e.type === "travel");
        }

        return <>{travel !== undefined && <>{travel.tranches} kms</>}</>;
      },
    });
  }

  return arrayCols;
};

export const inputsPrestationsList = (
  defaultRanges,
  formRef,
  setSearchState,
  setPagination,
  dispatchActionPrestations,
  defaultPagination,
  loading,
  searchState,
  advancedSearch,
  setAdvancedSearch,
) => {
  const {
    token: { colorPrimary },
  } = theme.useToken();

  return [
    {
      parentLabel: null,
      extraRowStyle: { alignItems: "center" },
      children: [
        {
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          label: "Filtre par interprète",
          name: "interprete",
          placeholder: "Filtre par interprète",
          allowClear: true,
          showSearch: true,
          value: searchState?.interprete || undefined,
          type: "dynamic-select",
          endPoint: "users?role=interprete",
          capitalize: false,
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserName(item),
              value: item._id,
            };
          },
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          visible: userHasLevel({
            not: {
              [roles.institution]: "r", //
            },
          }),
          label: "Filtre par institution",
          name: "institution",
          placeholder: "Filtre par institution",
          allowClear: true,
          showSearch: true,
          value: searchState?.institution || undefined,
          type: "dynamic-select",
          endPoint: "institutions",
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          capitalize: false,
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },

        {
          label: "Filtre par n° de commande",
          name: "reference",
          value: searchState?.reference || null,
          type: "input",
          xl: advancedSearch ? 6 : 5,
          lg: advancedSearch ? 5 : 4,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          visible: advancedSearch,
          label: "Filtre par date",
          name: "rangeDate",
          value: searchState?.rangeDate
            ? [
                dayjs(searchState?.rangeDate[0]),
                dayjs(searchState?.rangeDate[1]),
              ]
            : defaultRanges,
          type: "range-picker",
          xl: 6,
          lg: 6,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          visible: advancedSearch,
          label: "Filtre par bénéficiaire",
          name: "beneficiary",
          value: searchState?.beneficiary || null,
          type: "input",
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          visible:
            advancedSearch &&
            userHasLevel({
              not: {
                [roles.institution]: "r", //
                [roles.interprete]: "r", //
              },
            }),
          label: "Filtre par demandeurs",
          name: "institutionDemander",
          placeholder: "Filtre par demandeurs",
          allowClear: true,
          showSearch: true,
          value: searchState?.institutionDemander || undefined,
          type: "dynamic-select",
          endPoint: `users?subRole=${subRoles.institutionDemander}&dynamic=true`,
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserName(item),
              value: item._id,
            };
          },
          capitalize: false,
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          visible: advancedSearch,
          label: "Filtre par langue",
          name: "language",
          type: "select",
          value: searchState?.language || [],
          showSearch: true,
          allowClear: true,
          reset: true,
          multiple: false,
          selectContent: languagesList.sort((a, b) =>
            a.label.localeCompare(b.label),
          ),
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          label: "Filtre par contrôle",
          visible:
            advancedSearch &&
            userHasLevel({
              only: {
                [roles.admin]: "r", //
                [roles.permanance]: "r", //
              },
            }),
          name: "control",
          type: "select",
          value: searchState?.control || [],
          showSearch: true,
          allowClear: true,
          reset: true,
          multiple: true,
          selectContent: [
            ...statusControlList.map(item => {
              return {
                ...item,
                label: `1er ${item.label}`,
                value: `${item.value}_1`,
              };
            }),
            ...statusControlList.map(item => {
              return {
                ...item,
                label: `2ème ${item.label}`,
                value: `${item.value}_2`,
              };
            }),
          ],
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          label: "Informations avancée",
          visible: advancedSearch,
          name: "advancedCols",
          type: "switch",
          value: searchState?.advancedCols || false,
          xl: 6,
          lg: 5,
          md: 6,
          sm: 8,
          xs: 12,
        },
        // {
        //   label: "Filtre par batch",
        //   visible:
        //     advancedSearch &&
        //     userHasLevel({
        //       only: {
        //         [roles.admin]: "r", //
        //         [roles.permanance]: "r", //
        //       },
        //     }),
        //   name: "batch",
        //   type: "select",
        //   value: searchState?.batch || "all",
        //   showSearch: true,
        //   allowClear: true,
        //   reset: true,
        //   selectContent: [
        //     {
        //       label: `Tous`,
        //       value: `all`,
        //     },
        //     {
        //       label: `Partagé`,
        //       value: `batch_shared`,
        //     },
        //     {
        //       label: `Groupé`,
        //       value: `batch_grouped`,
        //     },
        //   ],
        //   xl: 6,
        //   lg: 5,
        //   md: 6,
        //   sm: 8,
        //   xs: 12,
        // },
        {
          type: "component",
          style: { textAlign: "left" },
          xl: advancedSearch ? 24 : 7,
          lg: 7,
          md: 7,
          sm: 12,
          xs: 24,
          label: "",
          component: () => (
            <Space
              align={"center"}
              style={{ width: "100%", justifyContent: "flex-end" }}
            >
              <Button
                loading={loading}
                size={"middle"}
                type={"primary"}
                style={{
                  marginTop: "-6px",
                  width: "100%",
                  fontWeight: "bold",
                }}
                icon={<BiSearch style={{ marginTop: "0px" }} size={25} />}
                onClick={() => formRef.current.submit()}
              >
                Rechercher
              </Button>
              <Button
                style={{
                  marginTop: "-7px",
                  width: "100%",
                  color: colorPrimary,
                  fontWeight: "bold",
                }}
                icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}
                onClick={async () => {
                  localStorage.removeItem("prestationsSearcher");

                  setSearchState({});

                  formRef.current.resetFields(); // Reset the form fields using the ref

                  formRef.current.setFieldsValue({
                    interprete: undefined,
                    institution: undefined,
                    institutionDemander: undefined,
                    rangeDate: defaultRanges,
                    reference: null,
                    beneficiary: null,
                    language: [],
                    control: [],
                  });
                  // formRef.current.setFieldsValue(initialValuesForm);
                  setPagination(defaultPagination);
                  await dispatchActionPrestations();
                }}
                size="middle"
                type={"text"}
              >
                Réinitialiser
              </Button>
              <Button
                style={{
                  marginTop: "-7px",
                  width: "100%",
                  color: colorPrimary,
                  fontWeight: "bold",
                }}
                icon={
                  advancedSearch ? (
                    <FaChevronUp style={{ marginTop: "-3px" }} size={15} />
                  ) : (
                    <FaChevronDown style={{ marginTop: "-3px" }} size={15} />
                  )
                }
                onClick={async () => {
                  setAdvancedSearch(!advancedSearch);
                }}
                size="middle"
                type={"text"}
              >
                {advancedSearch ? "Moins de filtres" : "Plus de filtres"}
              </Button>
            </Space>
          ),
        },
      ],
    },
  ];
};

export const defaultSorterByTab = tab => {
  switch (tab) {
    case "draft":
    case "schedules":
    case "min24h":
    case "today":
    case "toConfirm":
      return {
        key: "finalStartDate",
        order: "ascend",
      };
    case "total":
    case "done":
    case "cancelled":
    case "nonClosed":
      return {
        key: "finalStartDate",
        order: "descend",
      };
    default:
      return {
        key: "finalStartDate",
        order: "ascend",
      };
  }
};
